import styled from 'styled-components/macro'


export const HomePageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`